<template>
    <div class="outer" @mouseenter="isHover = true;" @mouseleave="isHover = false;">
        <div class="d-flex align-items-center justify-content-center">
            <span class="mr-3"> {{ zonesWithPrices.length }} / {{ forecastWindows.length }} </span>
            <CheckMarkIcon v-if="zonesWithPrices.length === forecastWindows.length" class="icon" />
        </div>
        <div v-if="isHover" class="allPricesTooltip">
            <div class="inner" v-for="fw in forecastWindows" :key="fw.id">
                <div>{{ fw.zone.name }}</div>
                <div class="right">{{ getPriceForZone(fw.zone).value }} {{ getPriceForZone(fw.zone).currency }}</div>
            </div>
        </div>
    </div>
</template>
<script>
import CheckMarkIcon from "@/components/forecasts/elements/icons/CheckMarkIcon";
import ForecastValidator from "@/components/forecasts/validation/forecastValidator";
export default {
    components: { CheckMarkIcon },
    props: {
        item: {
            type: Object,
            required: true
        },
        forecastWindows: {
            type: Array,
            required: true
        }
    },
    data() {
        return {
            isHover: false
        };
    },
    computed: {
        zonesWithPrices() {
            return this.forecastWindows.filter(fw => this.hasPriceForZone(fw.zone));
        }
    },
    methods: {
        getPriceForZone(zone) {
            return ForecastValidator.getItemPriceForZone(this.item, zone);
        },
        hasPriceForZone(zone) {
            return ForecastValidator.hasItemPriceForZone(this.item, zone);
        }
    }
};
</script>
<style scoped lang="scss">
.outer {
    cursor: pointer;
}
.allPricesTooltip {
    position: absolute;
    background-color: #f4f4f4;
    z-index: 10;
    max-height: 200px;
    overflow-y: auto;
    padding: 15px;
    border: 1px solid #000000;

    .inner {
        display: flex;
        .right {
            margin-left: auto;
            padding-left: 25px;
        }
    }
}
.icon {
    height: 1.4em;
}
span {
    font-size: 16px;
}
</style>



// WEBPACK FOOTER //
// AllPricesInfo.vue?e5b8c7dc